import classNames from "classnames";
import { GameSocialLinks } from "../game-social-links";
import { GameVideo } from "../game-video/game-video";
import { IGame } from "./game.types";

export const Game: IGame = (props) => {
  const { name, video, smallIcons, image, className } = props;

  return (
    <div className={classNames("game", className)}>
      {video && (
        <GameVideo
          {...video}
          poster={image?.url}
          id={name}
        />
      )}
      <div className="w-full h-[50px] flex flex-row items-center bg-base-05 justify-between px-[10px] pr-[2px] md:pr-[17px]">
        <h6 className="relative top-[2px] font-600 text-[16px] leading-[16px] 2xl:top-[4px] 2xl:text-[25px] 2xl:leading-[25px] uppercase">
          {name}
        </h6>

        <GameSocialLinks
          game={props}
          smallIcons={smallIcons}
          className="relative top-[2px]"
        />
      </div>
    </div>
  );
};
